import {reducer} from './helpers'

import {ACTIVATE_AB_TEST} from '../actions/ab'
import Features from '../feature-flags'
import * as ab from '../store/ab'

/**
 * How to formulate an action for an A/B test:
 *
 * {
 *   type: 'ACTIVATE_AB_TEST',
 *   payload: {
 *     test: {{camel case identifier string, e.g. 'getStartedButton'}},
 *     variation: {{test variation number, e.g. 1}},
 *   },
 * }
 */

const initialState = {
  [ab.ACCOUNT_BALANCE]: Features.enabled('ACCOUNT_BALANCE') ? 1 : 0,
  [ab.BUY_PATH]: Features.enabled('BUY_PATH') ? 1 : 0,
  [ab.LOOKBUILDER_PDP_ENTRYPOINT]: Features.enabled('LOOKBUILDER_PDP_ENTRYPOINT') ? 1 : 0,
  [ab.RENTAL_PAGE_HERO_CTA]: Features.enabled('RENTAL_PAGE_HERO_CTA') ? 1 : 0,
  [ab.STYLED_LOOKS_ONBOARDING]: Features.enabled('STYLED_LOOKS_ONBOARDING') ? 1 : 0,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case ACTIVATE_AB_TEST:
      return {
        [payload.test]: payload.variation,
      }
    default:
      return null
  }
})
